import { render } from "@wordpress/element";
import UserPageApp from "./UserPageApp";

render(<UserPageApp />, document.getElementById("wpqt-public-user-app"));
